import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Gem } from 'lucide-react';
import { Button } from '@/components/ui-kit/button';

interface EmptyStateProps {
  title?: string;
  description?: string;
  ctaLabel?: string;
  ctaHref?: string;
  onCtaClick?: () => void;
}

export function EmptyState({
  title,
  description,
  ctaLabel,
  ctaHref,
  onCtaClick,
}: EmptyStateProps) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center py-20 px-6 text-center">
      <div className="rounded-full bg-blue-500/10 p-6 mb-6">
        <Gem className="h-16 w-16 text-blue-500" />
      </div>
      <h2 className="text-2xl font-bold text-white mb-2">{title ?? t('EMPTY_TITLE')}</h2>
      <p className="text-zinc-400 max-w-md mb-8">{description ?? t('EMPTY_DESCRIPTION')}</p>
      {ctaHref ? (
        <Link
          to={ctaHref}
          className="rounded-md bg-[#2563EB] px-6 py-2.5 text-sm font-semibold text-white hover:bg-blue-600 transition"
        >
          {ctaLabel ?? t('EMPTY_CTA')}
        </Link>
      ) : (
        <Button
          onClick={onCtaClick}
          className="bg-[#2563EB] hover:bg-blue-600 text-white font-semibold px-6"
        >
          {ctaLabel ?? t('EMPTY_CTA')}
        </Button>
      )}
    </div>
  );
}